import { render, staticRenderFns } from "./CommentLikeCounter.vue?vue&type=template&id=1c1d6b5a&scoped=true&"
import script from "./CommentLikeCounter.vue?vue&type=script&lang=js&"
export * from "./CommentLikeCounter.vue?vue&type=script&lang=js&"
import style0 from "./CommentLikeCounter.vue?vue&type=style&index=0&id=1c1d6b5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d6b5a",
  null
  
)

export default component.exports